import React from 'react'

import { Skeleton, useIsDesktop } from '@rewardops/ui'

export const loadingCardStyling =
  'flex flex-col gap-1 min-h-[235px] md:min-h-[261px] lg:min-h-[261px] pb-2 cursor-pointer md:rounded-lg sm:rounded-none md:border border-b border-r sm:-mx-px border-zinc-200 hover:shadow-[0_3px_8px_0px_rgba(0,0,0,0.2)]'

export const RetailerCardSkeleton: React.FC = () => {
  const isDesktop = useIsDesktop()

  return (
    <div
      className={`${loadingCardStyling} ${
        isDesktop ? 'w-[260px]' : 'w-[180px]'
      } shrink-0`}
    >
      <div className="relative mx-8 mt-8 h-[130px]">
        <Skeleton className="h-[100px] w-full" />
      </div>
      <div className="mx-8 my-4 space-y-2.5">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  )
}

export default RetailerCardSkeleton
